/**
 * Shared constants for realized preset functionality
 */

export const EVENTS = {
  COLOR_LOADING_STARTED: 'colorLoadingStarted',
  COLOR_LOADING_COMPLETED: 'colorLoadingCompleted',
  COLOR_LOADING_FAILED: 'colorLoadingFailed'
};

export const TIMEOUTS = {
  COLOR_LOADING_MAX_WAIT: 5000, // 5 second fallback timeout
	RANDOMIZER_RETRY_DELAY: 500,  // Retry delay for fallback
	COLOR_LOADING_DEBOUNCE: 300,  // Debounce delay for color loading
	IMAGE_LOADING_SLEEP: 1000 	
};

export const SELECTORS = {
  PRESET_NODE_CONTAINER: '.js-preset-node-container',
  ITEM_MODEL_SELECT: '.js-item-model-select',
  COLOR_SELECT: '.js-color-select',
  INVENTORIUS_SELECT: '.js-inventorius-select',
  COLOR_DROPDOWN_CONTAINER: '.js-color-dropdown-container'
};
